import React from 'react';
import BarraLateralCV from './controladorVista/barraLateralCV';
import { IBarraLateralProps } from './interfaces';

const BarraLateral: React.FunctionComponent<IBarraLateralProps> = (props) => <BarraLateralCV {...props} />;

export { IBarraLateralProps };

export default BarraLateral;
